<template>
    <div class="">
        <div class="col-md-12">
            <h2> {{ labels.title }} </h2>
        </div>
        <div class="row mt-5">
            <div class="col-md-6 d-flex justify-content-end">
                <h4>{{ labels.fechaCierre }}</h4>
            </div>
            <div class="col-md-2 d-flex justify-content-start">
                <input type="month" v-model="fechaCierre" class="form-control">
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-md-6 d-flex justify-content-end">
                <h4>{{ labels.actControlCierre }}</h4>
            </div>
            <div class="col-md-2 d-flex justify-content-start">
                <input type="checkbox" v-model="chkCierre" class="">
            </div>
        </div>
        <div class="col-md-12 mt-4">
            <b-button type="button" id="create-btn" @click="GuardarCierre">{{ labels.save }}</b-button>
        </div>
    </div>
</template>

<script>
import FechaRegistro from '../../../services/FechaRegistro';

export default {
    name : 'FechaDeRegistro',
    data : () => ({
        fechaCierre : '',
        chkCierre : false
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Fecha de registro",
                    fechaCierre : 'Fecha cierre:',
                    actControlCierre : 'Activación control cierre:',
                    save : 'Guardar'
                }
            }else{
                return {
                    title: "Registration date",
                    fechaCierre : 'Closing date:',
                    actControlCierre : 'Closing control activation:',
                    save : 'Save'
                }
            }
        }
    },
    methods:{
        GuardarCierre(){
            if(this.fechaCierre != ''){
            
                const info = {
                    'fecha' : this.fechaCierre,
                    'estadoCierre' : this.chkCierre,
                    'idUser' : this.$store.state.userId
                }

                FechaRegistro.updateFechaRegistro(info)
                .then((res) => {
                    // console.log(res.data);
                    this.$toast.success(res.data.msg)
                })
                .catch((err) => {
                    if(err.response.status == 404 || err.response.status == 400 || err.response.status == 500){
                        this.$toast.error(err.response.data.msg)
                    }else{
                    this.$toast.error("Algo pasó, intentalo de nuevo")
                    }
                })

            }else{

                this.$toast.error('Diligenciar la fecha.')
            }
        }
    },
    mounted(){

        FechaRegistro.getAllFechaRegistro()
        .then((res) => {
            // console.log(res.data);
            this.fechaCierre = res.data.periodo_cierre
            this.chkCierre = res.data.flag_cierre
        })
        .catch((err) => {
            console.log(err);
            if(err.response.status == 500){
                this.$toast.error(err.response.data.msg)
            }else{
                this.$toast.error("Algo pasó, intentalo de nuevo")
            }
        })
    }
}
</script>

<style>

</style>